import React, { useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import {IconButton, Stack, Table, TableContainer, TableHead, TableRow} from '@mui/material';
import Paper from '@mui/material/Paper';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import api from '../../../services/api';
import { SPSelectField } from './SPSelectField';
import { statuses } from '../../../schema/statuses';
import Box from '@mui/material/Box';
import toast from 'react-hot-toast';
import { MoreOptions } from '../assets/MoreOptions';
import ConfirmDialog from '../layout/ConfirmDialog';
import AddIcon from "@mui/icons-material/Add";
import {groupGuide} from "../../../schema/groupGuide";
import {SlidingPaneAddNew} from "../../Page/SlidingPaneAddNew";

export const CustomFieldForGroupGuide: FieldComponent<any, any> = ({
  onChange,
  isActive,
  value,
  hasTooltip,
  disabled,
  mui,
  column,
  allValue,
  defaultValue,
  title,
}) => {
  const [guides, setGuides] = useState<any>(defaultValue ? defaultValue : []);
  const [loading, setLoading] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: groupGuide,
    row: {},
  });
  const [guideStatuses, setGuideStatuses] = useState<any[]>([]);

  const fetchStatuses = useCallback(() => {
    setLoading(true);
    api.get('/statuses/guide').then((result: any) => {
      setGuideStatuses(result?.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchStatuses();
  }, []);

  const fetchGuides = useCallback(() => {
    setLoading(true);
    api.get(`/groups/guide-status/${allValue?.id}`).then((result: any) => {
      setGuides(result);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchStatuses();
  }, []);

  const handleChange = (statusId: number | null, groupGuideId: number) => {
    api
      .patch(`/groups/guide-status/${groupGuideId}`, {
        group_status_id: statusId,
      })
      .then((result: any) => {
        fetchGuides();
        toast.success(`Successfully saved guide status`);
      })
      .catch((error: any) => {
        toast.error(`Error while saving guide status`);
      });
  };

  const handleDelete = (groupGuideId: number, guideId: number) => {
    api
      .delete(`/groups/guide-status/${groupGuideId}`)
      .then((result: any) => {
        toast.success(`Successfully deleted guide`);

        setOpenConfirmDialog(false);
        setGuides(guides.filter((guide: any) => guide.id !== guideId));
      })
      .catch((error: any) => {
        toast.error(`Error while deleting guide`);
      });
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          aria-label="simple table"
          size="small"
          sx={{
            '& .MuiTableRow-root .MuiTableCell-root': {
              p: '5px',
            },
          }}
        >
          <TableHead
            sx={{
              '& .MuiTableCell-root': {
                color: 'inherit',
                border: 'none',
              },
              '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                border: 'none',
                fontSize: '14px',
                p: '10px',
              },

              background: '#256861',
              color: '#fff',
            }}
          >
            <TableRow>
              <TableCell>Guide</TableCell>
              <TableCell
                sx={{
                  width: '80px',
                }}
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  width: '50px',
                  textAlign: 'center',
                }}
              >
                #
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {guides.map((guide: any) => {
              const status = guideStatuses.find(
                (status: any) => status.id === guide?.pivot?.guide_status_id
              );

              return (
                <TableRow>
                  <TableCell
                  sx={{
                    background: status?.color?.color || ''
                  }}
                  >{guide?.name}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        '& .MuiInputBase-root.MuiOutlinedInput-root': {
                          cursor: 'pointer',
                        },
                        '& .MuiInputBase-root.MuiOutlinedInput-root:hover': {
                          background: '#ebebeb',
                        },
                      }}
                    >
                      <SPSelectField
                        onChange={(value: any) => {
                          handleChange(value?.id || null, guide.pivot.id);
                        }}
                        schema={statuses.guide}
                        defaultValue={status}
                        forcedValue={undefined}
                        disabled={false}
                        isMissing={false}
                        accordingToValue={undefined}
                      />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <MoreOptions
                      clickOnEdit={() => {}}
                      clickOnDelete={() => {
                        setOpenConfirmDialog(guide);
                      }}
                      hideEdit={true}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px',
        }}
      >
        <IconButton
          onClick={() => {
            setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: allValue});
          }}
        >
          <AddIcon color={'primary'}/>
        </IconButton>
      </Stack>

      {openConfirmDialog && (
        <ConfirmDialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
          onConfirm={() => {
            handleDelete(openConfirmDialog.pivot.id, openConfirmDialog.id);
          }}
        />
      )}
      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={
              openedSlidingPaneAddNew?.hasOwnPane
                ? undefined
                : openedSlidingPaneAddNew?.row?.id
            }
            onSubmit={() => {
              setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: {}});
              fetchGuides();
            }}
            propertiesFromTable={
              openedSlidingPaneAddNew?.row ? openedSlidingPaneAddNew?.row : {}
            }
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: {}});
            }}
          />
        </>
      )}
    </>
  );
};

CustomFieldForGroupGuide.includes = (query, value) => true;

CustomFieldForGroupGuide.comparator = () => 0;

CustomFieldForGroupGuide.FilterRenderer = TimeFilter;
